module.exports = __webpack_public_path__ + "img/icon-7.8f73f8e1.png";